import Vue from 'vue';
import store from '@store'
import router from '@router'
import { getUrlParameter } from "@utils/window-history";
import formatStringToValue from "@utils/format-string-to-value";
import dialogMap from "./global-plugin"
import i18n from '@lang'

function createConstructor(name, options = {}) {
  const component = dialogMap[name];
  const DialogConstructor = Vue.extend(component);

  const instance = new DialogConstructor({
    store,
    router,
    i18n,
    data: {
      visible: false,
      isQuerySet: false,
      name,
      ...options
    }
  });

  instance.$mount();
  instance.visible = true;

  return instance;
}

export default function(name = '', options = {}) {
  if(dialogMap[name] === undefined) {
    console.warn('Undefined dialog name or not found !');
    return
  }

  return createConstructor(name, options)
}

// autoOpenGlobalDialog();

export function autoOpenGlobalDialog() {
  Object.keys(dialogMap).forEach((name) => {
    // const query = getUrlParameter(`dialog${formatTextUpperCasefirst(name)}Visible`);
    const query = getUrlParameter(`dialog${name}Visible`);

    if(formatStringToValue(query)) {
      createConstructor(name)
    }
  });
}
